import { render, staticRenderFns } from "./MyInvoices.vue?vue&type=template&id=19902813&scoped=true&"
import script from "./MyInvoices.vue?vue&type=script&lang=js&"
export * from "./MyInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19902813",
  null
  
)

export default component.exports